import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, FormControl } from 'react-bootstrap'
import * as request from 'services/request'

class CreateTenantModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      name: ''
    }

    this.handleNameChanged = this.handleNameChanged.bind(this)
    this.save = this.save.bind(this)
  }

  handleNameChanged (e) {
    this.setState({ name: e.target.value })
  }

  async save () {
    const { onClose } = this.props
    const { name } = this.state

    this.setState({ name: '' })

    await request.authorized('/tenants', {
      method: 'POST',
      body: { name }
    })

    onClose()
  }

  render () {
    const { show, onClose } = this.props

    return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Add new Tenant</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <FormControl
            type='text'
            placeholder='Tenant Name'
            onChange={this.handleNameChanged}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={onClose}>Cancel</Button>
          <Button bsStyle='primary' onClick={this.save}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

CreateTenantModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func
}

export default CreateTenantModal



// WEBPACK FOOTER //
// ./src/pages/admin/tenants/create-modal.js